module.exports = __webpack_public_path__ + "img/last_section.3c74d5f3.png";